'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
import { bindAll } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Button } from 'foundations-components/transitional/components/Button';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `simpleMenusLib.components.modals.deleteNodeModal.${key}`;
const HOC = Component => {
  class WithDeleteMenuNodeModal extends PureComponent {
    constructor(props) {
      super(props);
      bindAll(this, ['deleteMenu', 'onCancel', 'onDeleteClick']);
      this.state = {
        open: false
      };
    }
    onDeleteClick() {
      if (this.props.hasChildren) {
        this.setState({
          open: true
        });
      } else {
        this.props.deleteNode();
      }
    }
    deleteMenu() {
      this.props.deleteNode();
      this.setState({
        open: false
      });
    }
    onCancel() {
      this.setState({
        open: false
      });
    }
    renderModal() {
      if (!this.state.open) return null;
      const linkLabel = this.props.linkLabel || text(i18nKey('placeholder'));
      return /*#__PURE__*/_jsxs(Modal, {
        size: "auto",
        use: "danger",
        width: 600,
        children: [/*#__PURE__*/_jsxs(DialogHeader, {
          children: [/*#__PURE__*/_jsx(DialogCloseButton, {
            onClick: this.onCancel
          }), /*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('header'),
              options: {
                linkLabel
              }
            })
          })]
        }), /*#__PURE__*/_jsx(DialogBody, {
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('body'),
              options: {
                linkLabel
              }
            })
          })
        }), /*#__PURE__*/_jsx(DialogFooter, {
          children: /*#__PURE__*/_jsx(Button, {
            use: "danger",
            onClick: this.deleteMenu,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('button')
            })
          })
        })]
      });
    }
    render() {
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, {
        deleteMenuNodeModal: this.renderModal(),
        deleteNode: this.onDeleteClick
      }));
    }
  }
  WithDeleteMenuNodeModal.defaultProps = {
    linkLabel: '',
    hasChildren: false,
    deleteNode: emptyFunction
  };
  WithDeleteMenuNodeModal.propTypes = {
    linkLabel: PropTypes.string.isRequired,
    hasChildren: PropTypes.bool.isRequired,
    deleteNode: PropTypes.func.isRequired
  };
  return WithDeleteMenuNodeModal;
};
export default function withDeleteMenuModal() {
  return HOC;
}